import React, { useEffect, useState } from "react";
import { Modal, Button, ListGroup, ListGroupItem } from "react-bootstrap";
import PropTypes from "prop-types";
import { useToken } from "../scripts/tokenContext";
import useApi from "../scripts/apiService";
import { useTranslation } from "react-i18next";

function ModalVersao({ show, onHide }) {
  const { t } = useTranslation();

  const { fetchData } = useApi();

  const [versionBack, setVersionBack] = useState({});
  const { token } = useToken();

  useEffect(() => {
    if (token) {
      const fetchDataVersion = async () => {
        try {
          const response = await fetchData("/version");
          setVersionBack(response.data);
        } catch (error) {
          console.error("Erro ao buscar os dados:", error);
        }
      };
      fetchDataVersion();
    }
  }, [token]);

  return (
    <Modal backdrop="static" centered size="md" show={show} onHide={onHide}>
      <Modal.Header closeVariant="white" closeButton>
        <Modal.Title>{t("Versão do")} Overview</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <ListGroup variant="flush">
          <ListGroupItem>{t("Versão do")} front-end: 3.9.0</ListGroupItem>
          <ListGroupItem>
            {t("Versão do")} back-end: {versionBack.version}
          </ListGroupItem>
        </ListGroup>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>
          {t("Fechar")}
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

ModalVersao.propTypes = {
  show: PropTypes.bool.isRequired,
  onHide: PropTypes.func.isRequired,
};

export default ModalVersao;
